module.exports = __webpack_public_path__ + "img/chargeStage_offline.5ad9c3f1.png";